module.exports = __webpack_public_path__ + "9035eefd99d046257e8c1c99612ef0ac.png";